function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#BFBBB7",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 3.188c0-.294-.224-.532-.5-.532h-5c-.276 0-.5.238-.5.531v4.25c0 .294.224.532.5.532h5c.276 0 .5-.238.5-.532v-4.25zM8 6.905H4V3.72h4v3.187z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.736 3.767l-1.994-1.063a.483.483 0 0 0-.668.238.548.548 0 0 0 .225.713l.76.403c-.021.058-.047.119-.047.184 0 .692.488 1.276.988 1.496v6.473c0 .293-.224.531-.5.531s-.5-.238-.5-.531v-4.25c0-1.283-1-2.356-2-2.603v-3.24C11 .945 10.127 0 9.024 0h-6C1.92 0 1 .946 1 2.117v11.89l-.724.385a.536.536 0 0 0-.276.475v1.594c0 .293.248.539.524.539h11c.276 0 .476-.246.476-.539v-1.594a.536.536 0 0 0-.276-.475L11 14.008V6.465c.5.22 1 .804 1 1.496v4.25c0 .879.673 1.594 1.5 1.594S15 13.09 15 12.21V4.242a.525.525 0 0 0-.264-.475zM11 15.937H1v-.741l.724-.385A.536.536 0 0 0 2 14.336V2.117c0-.586.472-1.054 1.024-1.054h6c.551 0 .976.468.976 1.054v12.219c0 .201.107.385.276.475l.724.385v.742z"
}));

var SvgFuel = function SvgFuel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFuel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fuel.c522cbf2.svg";
export { ForwardRef as ReactComponent };